import { useQuery } from '@tanstack/react-query';
import { resetPasswordKeys } from './resetPasswordKeys';
import { validateResetLink } from '@/services/forgot-password.service';
import type { ValidateResetLinkResponse } from '@/services/forgot-password.types';

const useValidateResetLinkQuery = ({ ott }: { ott?: string }) =>
  useQuery<ValidateResetLinkResponse>({
    queryKey: resetPasswordKeys.validate(ott),
    enabled: !!ott,
    retry: false,
    queryFn: () => validateResetLink({ ott: ott as string }),
  });

export default useValidateResetLinkQuery;
